import { NgModule, APP_INITIALIZER, LOCALE_ID } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { platformBrowserDynamic } from '@angular/platform-browser-dynamic';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';








import { HttpModule } from '@angular/http';
import { DevExtremeModule } from 'devextreme-angular';
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';


// Routing
import { RouterModule, Routes } from '@angular/router'; // Routing
// Routing Module
import { AppRoutingModule } from './app.routing';


// Services
import { ConfigService } from './shared/services/configuration/config.service';
import { AuthService } from "./shared/services/auth/auth.service";
import { UserService } from "app/shared/services/users/user.service";
import { UtilService } from "app/shared/services/utilities/utils.service";
import { ApiService } from "app/shared/services/api/api.service";

// // Guarding
import { AuthGuard } from './shared/services/guards/auth.guard';



// Components
import { AppComponent } from './app.component';



//Layouts
import { FullLayoutComponent } from './layouts/full-layout.component';
import { SimpleLayoutComponent } from './layouts/simple-layout.component';

// Directives
import { SIDEBAR_TOGGLE_DIRECTIVES } from './shared/directives/sidebar.directive';
import { NAV_DROPDOWN_DIRECTIVES } from './shared/directives/nav-dropdown-toggle.directive';
import { AsideToggleDirective } from './shared/directives/aside.directive';
import { ImageDirective } from './shared/directives/image.directive';
import { BreadcrumbsComponent } from './shared/components/breadcrumbs.component';
// import { LetterAvatarDirective } from './shared/directives/avatar.directive';



// Startup Service // Load the Configuration File Settings
export function startupServiceFactory(startupConfigService: ConfigService): Function {
  return () => {
    // Step 1 Load Configuration file
    startupConfigService.getConfiguration();
    // Step 2 :: Load Saved User

  }
}

@NgModule({
  declarations: [
    AppComponent,
    FullLayoutComponent,
    SimpleLayoutComponent,
    SIDEBAR_TOGGLE_DIRECTIVES,
    NAV_DROPDOWN_DIRECTIVES,
    AsideToggleDirective,
    ImageDirective,
    BreadcrumbsComponent,
    // LetterAvatarDirective,



  ],
  imports: [
    AppRoutingModule,
    BrowserModule, CommonModule, HttpModule, FormsModule, DevExtremeModule,
    NgbModule.forRoot(),
  ],
  providers: [
    ApiService,
    UtilService,
    AuthGuard,
    ConfigService,
    UserService,
    AuthService,
    {
      // Provider for APP_INITIALIZER
      provide: APP_INITIALIZER,
      useFactory: startupServiceFactory,
      deps: [ConfigService],
      multi: true
    },

    { provide: LOCALE_ID, useValue: "en_ZA" }, //replace "en-US" with your locale

  ],


  bootstrap: [AppComponent]
})
export class AppModule { }



// WEBPACK FOOTER //
// C:/Software Development/Devpark/biz-app/src/app/app.module.ts